import React, { useEffect, useRef, useState } from "react";
import { Button as UploadButton, IconButton } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import AuthService from "../../Components/auth/AuthService";
import { hideLoading, showLoading, useLoadingDispatch } from "../../context/loadingContext";
import { Table, Button as AntButton, Input, Checkbox, Descriptions, Tag, Row, Col, Divider, Flex, Tooltip, Modal, Image, Typography, DatePicker } from "antd";
import { ArrowLeftOutlined, CalendarOutlined, DeleteFilled, ExportOutlined, InfoCircleFilled, InfoCircleOutlined, InfoCircleTwoTone, NumberOutlined, TagOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { extractOriginalFileName, getUploadUrl, handleDeleteCurrentFile, handleDeleteFile, handleSubmitImage, uploadFileToS3 } from "../../Components/common/CommonFun";
import { env, wms_uploads_cdn } from "../../Components/config";
import { useSelector } from "react-redux";
import { showMessage } from "../../Components/Utils/message";
import dayjs from "dayjs";
import ScanInput from "../Scan/ScanInput";
import ScanSelect from "../Scan/ScanSelect";
import ProductInfoModal from "../../Components/Modals/ProductInfoModal";
import ProductScanSelect from "../Scan/ProductScanSelect";
import CustomTag from "../../Components/CustomTag";
import InfoCards from "../../Components/InfoCards";
import DetailsGrid from "../../Components/common/DetailsGrid";
import { getProductImageUrl } from "../../utils";

const ReceiveReturnedStock = () => {
  const { products, locations } = useSelector((state) => state.AppState?.userCreds);
  const { TextArea } = Input;
  const { Text } = Typography;
  let layoutDispatch = useLoadingDispatch();
  const Auth = new AuthService();
  const navigate = useNavigate();
  const [documentNumber, setDocumentNumber] = useState("");
  const [receivedItems, setReceivedItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [stockTransactions, setStockTransactions] = useState([])
  const [modalVisible, setModalVisible] = useState(false);
  const [allLocations, setAllLocations] = useState([]);
  const [notes, setNotes] = useState("");
  const [files, setFiles] = useState([]);
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);
  const [DetailsCM, setDetailsCM] = React.useState(null);
  const [returnedStock, setReturnedStock] = useState({
      product: "",
      product_id: '',
      location: "",
      location_id: null,
      quantity: "",
      productText: '',
      locationText: '',
      productStatus: null,
      locationStatus: null,
      expiry_date: null,
      fullPallet: false,
      fullPalletShow: false,
      remainQtyShow: false,
      remaining_quantity_check: false,
      supplier_batch_code: ''
    });
  const [selectedProductLocations, setSelectedProductLocations] = useState([])
  const [posted, setPosted] = useState(false);
    const [postedAt, setPostedAt] = useState(null);
  const [currentProduct, setCurrentProduct] = useState(null)
  
  const imageUrl = getProductImageUrl(currentProduct);

     const productRef = useRef(null);
      useEffect(() => {
        if (modalVisible) {
          setTimeout(() => {
            productRef.current?.focus();
          }, 100);
        }
      }, [modalVisible]);

  const handlePOScanValue = (value, scanResult) => {
    setDocumentNumber(value);

    // Run the submit directly if the input is from scan
    if (scanResult) handleSubmit(value);
  };

  const handleSubmit = async () => {
    setNotes("");
    setFiles([]);
    setCurrentItemFiles([]);
    setDeletedFiles([]);
    if (documentNumber.trim() === "") {
      showMessage('error',"Please enter the Document Number.");
      return;
    }
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/ns/get-credit-note?id=${documentNumber}`);
      if (res.ack) {
        setNotes(res?.order[0]?.notes)
        setCurrentItemFiles(res?.order[0]?.files ? JSON.parse(res?.order[0]?.files) : [])
        const allItems = res?.order;
        const updatedItems = allItems.map((item) => ({
          ...item,
          quantityAdded: Number(item.added_quantity) || 0,
          remaining_quantity: item?.batch_quantity - Number(item.added_quantity)
        }));
        setDetailsCM(updatedItems ? updatedItems[0] : [])
        setPosted(res?.order[0].posted_by > 0 ? true : false);
        setPostedAt(res?.order[0].posted_at)
        setReceivedItems(updatedItems);
        console.log(updatedItems);
        
      } else {
        showMessage('error', res?.message);
        setReceivedItems([]);
        setDetailsCM(res)
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'something went wrong')

    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const handleSelect = async (record) => {
      showLoading(layoutDispatch)
  
      const dataToSend = {
        transaction_id: record?.internal_id,
        // transaction_type: 2,
        // purchase_order_details_batch_id: record?.purchase_order_details_batch_id,
        product_netsuite_id: record?.product_netsuite_id
      }
  
      try {
        const res = await Auth.fetch(`/stock/credit-stock-detail`, {
          method: 'POST',
          body: JSON.stringify(dataToSend)
        });
        if (res?.ack) {
          const totalQuantityAdded = res?.stock_txns.reduce((sum, txn) => sum + (txn.quantity || 0), 0);
          const currentItemBatchId = res?.stock_txns[0]?.product_netsuite_id;
          const updatedRemainingQty = record?.batch_quantity - totalQuantityAdded;
          const updatedRecord = { ...record, remaining_quantity: updatedRemainingQty };
          const updatedReceivedData = receivedItems.map(item => {
            if (item.product_netsuite_id === currentItemBatchId) {
              return { ...item, remaining_quantity: updatedRemainingQty, quantityAdded: totalQuantityAdded };
            }
            return item;
          });
  
        const selectedProduct = products?.find((pro) => pro?.netsuite_id == record?.product_netsuite_id);
        const selectedProductCasesInPallets = selectedProduct?.cases_in_pallets
        const capacityStaus = updatedRemainingQty >= selectedProductCasesInPallets ? true : false;
          if (capacityStaus) {
            setReturnedStock({ ...returnedStock, fullPalletShow: true, remainQtyShow: false})
          } else {
            setReturnedStock({ ...returnedStock, fullPalletShow: false, remainQtyShow: true})
          }
          setSelectedItem(updatedRecord);
          setReceivedItems(updatedReceivedData)
          setStockTransactions(res?.stock_txns);
          // setModalVisible(true);
          const hasLocations = await getLocations();
          console.log('hasLocations', hasLocations);
          
                if (hasLocations) {
                  setModalVisible(true);
                } else {
                  showMessage("error", "No locations available");
                }
        } else {
          showMessage('err', res?.message)
          setStockTransactions([])
        }
      } catch (err) {
        console.log(err);
        showMessage('error', 'something went wrong')
      } finally {
        hideLoading(layoutDispatch)
      }
    };


    const getLocations = async () => {
        showLoading(layoutDispatch)
    
        try {
          const res = await Auth.fetch(`/location/locations`);
          if (res?.ack) {
            console.log(res?.locations, 'locations');
              // setSelectedLocations(res?.locations)

              setAllLocations(res?.locations)
               return true; 
          } else {
            showMessage('err', res?.message)
            setAllLocations([])
             return false; 
          }
        } catch (err) {
          console.log(err);
          showMessage('error', 'something went wrong')
        } finally {
          hideLoading(layoutDispatch)
        }
      };

      const handleModalCancel = () => {
    setReturnedStock({ product: "", product_id: '', location: "", location_id: null, quantity: "", productText: '', locationText: '', productStatus: null, locationStatus: null, expiry_date: null, fullPallet: false, remaining_quantity_check: false, fullPalletShow: true })
    setModalVisible(false);
  };

  const handleModalOk = async () => {
      if(!returnedStock?.location_id) return showMessage('error', 'Location is required')
      if(!returnedStock?.supplier_batch_code) return showMessage('error', 'Supplier batch code is required')
      if(!returnedStock?.expiry_date) return showMessage('error', 'expiry date is required')
      if(Number(returnedStock?.quantity) < 1) return showMessage('error', 'Quantity Must be grater than zero')
      const dataToSend = {
        product_netsuite_id: returnedStock?.product_id,
        location_id: returnedStock?.location_id,
        quantity: returnedStock?.quantity,
        netsuite_transaction_id: selectedItem?.internal_id,
        credit_note_detail_id: selectedItem?.credit_note_detail_id,
        batch_code: selectedItem?.batch_code,
        expiry_date: dayjs(returnedStock?.expiry_date).format('YYYY-MM-DD'),
        supplier_batch_code: returnedStock?.supplier_batch_code, 
  
      };
      showLoading(layoutDispatch);
      const submitStock = async (payload) => {
          showLoading(layoutDispatch);
          try {
            const res = await Auth.fetch('/stock/returned-stock-txn', {
          method: 'POST',
          body: JSON.stringify(payload),
        });
      
            if (res?.ack) {
               showMessage('success', res?.message)
          setReceivedItems(prevItems =>
          prevItems.map(item => {
            if (item.product_netsuite_id === selectedItem.product_netsuite_id) {
              const newRem = selectedItem?.remaining_quantity - Number(returnedStock?.quantity)
              const newDispatchedQTY = Number(item.quantityAdded) + Number(returnedStock?.quantity)
              return { ...item, quantityAdded: newDispatchedQTY, remaining_quantity: newRem };
            }
            return item;
          })
        );
          setReturnedStock({ product: "", product_id: '', location: "", location_id: '', quantity: "", productText: '', locationText: '', productStatus: null, locationStatus: null, expiry_date: null, fullPallet: false, remaining_quantity_check: false, fullPalletShow: true })
          setModalVisible(false);
            } else {
          showMessage('error', res?.message)

              hideLoading(layoutDispatch);
      
              if (res?.capacity_increased_by) {
                const cases_in_pallets = products?.find(pro => pro?.netsuite_id == returnedStock?.product_id)?.cases_in_pallets || 0;
                const capcityCal = res?.capacity_increased_by * cases_in_pallets;
                const plusSignWithCapcity = capcityCal < 0 ? `${Math.abs(capcityCal)}` : capcityCal;
                if (plusSignWithCapcity >= cases_in_pallets) return showMessage('error', 'Please select another location, this location capacity is full');
                Modal.confirm({
                  title: "Capacity Exceeded",
                  content: (
                    <div style={{ fontSize: 16 }}>
                      Location capacity exceeded by{" "}
                      <span style={{ color: "green", fontWeight: "bold", fontSize: 18 }}>
                        {Number(plusSignWithCapcity)?.toFixed(2)}
                      </span>{" "}
                      cases. Do you want to receive the stock anyway?
                    </div>
                  ),
                  okText: "Yes",
                  cancelText: 'Cancel',
                  width: 600,
                  okButtonProps: { size: "large" },
                  cancelButtonProps: { size: "large" },
                  onOk: () => submitStock({ ...payload, bypass_capacity_check: true }) 
                });
              }
            }
          } catch (err) {
            console.log(err);
            showMessage('error', 'Something went wrong');
            hideLoading(layoutDispatch);
          } finally {
            hideLoading(layoutDispatch);
          }
        };
      
        // First API call
        submitStock(dataToSend);
  
    };

  const productSelectValueChange = (val, isScanned) => {
    console.log('productSelectValueChange', val, isScanned);
  
    const selectedProduct = isScanned
      ? products?.find((pro) => pro?.code === val || pro?.barcode === val)
      : products?.find((pro) => pro?.netsuite_id === val);
  
    const matchedProduct = selectedItem?.product_netsuite_id === selectedProduct?.netsuite_id;
  
    if (selectedProduct && matchedProduct) {
        setCurrentProduct(selectedProduct)
        const productLocations = selectedProduct?.product_locations
        ? selectedProduct.product_locations.split(',').map((id) => Number(id.trim()))
        : [];
        const matchedLocations = locations.filter(location =>
          productLocations.includes(location.id)
        );
        setReturnedStock({ ...returnedStock, product_id: selectedProduct?.netsuite_id, productStatus: 'success', productText: selectedProduct?.name })
        setSelectedProductLocations(matchedLocations);
        
      } else {
        setCurrentProduct(selectedProduct)
        setReturnedStock({ ...returnedStock, productStatus: 'error', productText: 'Invalid Product', product: '', product_id: '' })
          showMessage('error', 'Invalid Product Selected');
        }
  };

  const locationSelectValueChange = (val, isScanned) => {
      console.log('locationSelectValueChange', val, isScanned);
      if (!returnedStock?.product_id) {
        showMessage('error', 'Please select a product first')
        setReturnedStock({ ...returnedStock, location_id: null })
        return;
      }
      if (isScanned) {
        const matched = locations?.find(item => item.code === val);
        if (matched) {
          setReturnedStock({ ...returnedStock, location_id: matched.id, expiry_date: dayjs(selectedItem?.expiry_date, 'YYYY-MM-DD') });
        } else {
          showMessage('error',"No matching location");
        }
      } else {
        setReturnedStock({ ...returnedStock, location_id: val, expiry_date: selectedItem?.expiry_date ?  dayjs(selectedItem?.expiry_date, 'YYYY-MM-DD') : null });
      }
    };

    const [selectedProductDetails, setSelectedProductDetails] = useState({
      totalStock: 0,
      code: '',
      name: '',
      productDetails: []
    })
    const [modalVisibleProduct, setModalVisibleProduct] = useState(false);
    
    const handleModalCancelProduct = () => {
      setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, product: null, productDetails: [] });
      setModalVisibleProduct(false);
    }
    const handleInfoClick = async (record) => {
      const product = products?.find((item) => item?.netsuite_id == record?.product_netsuite_id);
      showLoading(layoutDispatch)
      try {
  
        const res = await Auth.fetch(`/product/product-details?id=${record?.product_netsuite_id}`)
        if (res?.ack) {
          if (res?.product_details.length > 0) {
            const totalStock = res.product_details.reduce((sum, item) => sum + (Number(item.stock_level) || 0), 0);
            setSelectedProductDetails({ ...selectedProductDetails, totalStock: totalStock, code: product?.code, name:product?.name, productDetails: res?.product_details });
            setModalVisibleProduct(true);
            hideLoading(layoutDispatch)
  
          } else {
            showMessage('error', 'No Details');
            hideLoading(layoutDispatch)
          }
        } else {
          setSelectedProductDetails({ ...selectedProductDetails, totalStock: 0, code: product?.code, name:product?.name, productDetails: [] });
          showMessage('error', res?.message)
          hideLoading(layoutDispatch)
  
        }
  
      } catch (error) {
        showMessage('error', 'something went wrong');
        hideLoading(layoutDispatch)
      }
    };



  const dataCol = [
    {
      title: "Sr No.",
      render: (_, __, index) => <span>{index + 1}</span>,
      width: 60,
    },
    {
      title: "Item",
      sorter: (a, b) => (a?.product_name || "").localeCompare(b?.product_name || ""),
      render(record) {

        return (
          <Flex gap={5} align="center">
            <Tooltip title={'Product Info'}>

              <InfoCircleTwoTone style={{ fontSize: '22px', cursor: 'pointer' }} onClick={() => handleInfoClick(record)} />
            </Tooltip>
            <span>{`${record?.product_code} - ${record?.product_name}`}</span>

          </Flex>
        )

      }
    },
    {
      title: "Category",
      sorter: (a, b) => {
        const itemA = products?.find(
          (item) => item.netsuite_id == a?.product_netsuite_id
        );
        const itemB = products?.find(
          (item) => item.netsuite_id == b?.product_netsuite_id
        );
        return (itemA?.sub_category || "").localeCompare(
          itemB?.sub_category || ""
        );
      },
      render: (record) => {
        const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);
        return (
          <span>{item?.sub_category ? item?.sub_category : '-'}</span>
        )
      }
    },
    {
      title: 'Batch Code',
      dataIndex: 'batch_code',
      key: 'batch_code',
      
    },
    {
      title: 'Qty',
      sorter: (a, b) =>
        (a?.batch_quantity || 0) - (b?.batch_quantity || 0),
      render: (record) => {
        return <span>{record?.batch_quantity?.toLocaleString() || '0'}</span>;
      },
    },
    
    
    {
      title: 'Added Qty',
      sorter: (a, b) =>
        (a?.quantityAdded || 0) - (b?.quantityAdded || 0),
      render: (record) => {
        return <span>{record?.quantityAdded?.toLocaleString() || '0'}</span>;
      },
    },
    {
      title: 'Remaining Qty',
      sorter: (a, b) =>
        (a?.remaining_quantity || 0) - (b?.remaining_quantity || 0),  
      render: (record) => {
        return <Tag color={record?.remaining_quantity > 0 ? 'red' : 'green'}>{record?.remaining_quantity}</Tag>;
      },
    },
    {
          title: "Action",
          align: "center",
          render: (record) => (
            <Tooltip title="Select Item">
              <ExportOutlined
                className="animated-select-icon"
                onClick={() => handleSelect(record)}
              />
            </Tooltip>
          ),
        }
  ];
  const transactionCol = [
      // {
      //   title: "Item",
      //   render (record) {
      //     const item = products?.find((item) => item.netsuite_id == record?.product_netsuite_id);
      //     return (
      //       <Flex gap={5} align="center">
      //         <span>{item?.name}</span>
      //       </Flex>
      //     )
      //   }
      // },  
      {
        title: "Location",
        render(record) {
          const location = locations?.find((loc) => loc.id == record?.location_id);
          return (
            <Flex gap={5} align="center">
              <span>{location?.code}</span>
            </Flex>
          )
        }
      },
      {
        title: 'Supplier Batch Code',
        dataIndex: 'supplier_batch_code',
        key: 'supplier_batch_code',
      },
     {
              title: "Expiry",
              render: (record) => {
                const expiry = record?.expiry_date;
                if (!expiry) return "";
        
                const expiryDate = dayjs(expiry, "YYYY-MM-DD");
                const today = dayjs();
                const diffDays = expiryDate.diff(today, "day");
        
                let color = "green";
                if (diffDays < 0) {
                  color = "red";
                } else if (diffDays <= 7) {
                  color = "orange";
                }
        
                return <Tag style={{ fontSize: '15px' }} color={color}>{record?.expiry_date}</Tag>;
              }
            },
      {
        title: "Quantity",
        render(record) {
          return (
            <Flex gap={5} align="center">
              <span>{record?.quantity?.toLocaleString() || '0'}</span>
            </Flex>
          )
        }
      },
      {
  title: "User",
  render(record) {
    if (!record) return "";

    const user = record?.user_name || "";
    const helper = record?.helper_name || "";

    if (helper) {
      return (
        <>
          {helper}{" "}
          {user && (
            <Tooltip title={`${user}`}>
              <InfoCircleOutlined style={{ fontSize: 16, marginLeft: 6, color: "#1890ff" }} />
            </Tooltip>
          )}
        </>
      );
    }

    return <>{user}</>;
  }
},
      {
        title: "Created At",
        render(record) {
          return (
            <Flex gap={5} align="center">
              <span>{record?.createdAt ? dayjs(record?.createdAt).format('DD-MM-YYYY HH:mm:ss') : null}</span>
            </Flex>
          )
        }
      },
    ];

    if (!posted) {
        transactionCol.push({
          title: 'Action',
          align: "right",
          dataIndex: '',
          render(record) {
            return (
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <DeleteFilled
                  style={{
                    fontSize: "25px",
                    cursor: "pointer",
                    color: "#cd1437",
                  }}
                  onClick={() => {
                    Modal.confirm({
                      title: 'Delete Transaction',
                      centered: true,
                      content: `Are you sure you want to delete this transaction?`,
                      onOk: () => deleteTransaction(record.id),
                      okText: 'Delete',
                      cancelText: 'Cancel',
                      width: 600,
                      okButtonProps: { size: "large" },
                      cancelButtonProps: { size: "large" },
                    });
                  }}
                />
              </div>
            );
          },
        });
      }

      const deleteTransaction = async (id) => {
          showLoading(layoutDispatch);
          try {
            const res = await Auth.fetch(`/stock/delete-cn-transaction`, {
              method: "DELETE",
              body: JSON.stringify({ id: id })
      
            });
            if (res?.ack) {
              showMessage('success', res?.message);
              setModalVisible(false);
              handleSubmit();
            } else {
              showMessage('error', res?.message);
              hideLoading(layoutDispatch);
            }
          } catch (err) {
            console.log(err);
            showMessage('error', err?.message);
            hideLoading(layoutDispatch);
          }
          // finally {
          //   hideLoading(layoutDispatch);
          // }
        };

        const fetchUpdatedDetails = async () => {
            showLoading(layoutDispatch);
            setNotes('')
            setFiles([])
            setCurrentItemFiles([])
            try {
              const res = await Auth.fetch(`/stock/credit-note-details?id=${receivedItems[0]?.id}`);
              if (res?.ack) {
                setNotes(res?.credit_note[0]?.notes)
                setCurrentItemFiles(res?.credit_note[0]?.files ? JSON.parse(res?.credit_note[0]?.files) : [])
                setPosted(res?.credit_note[0].posted_by > 0 ? true : false);
                setPostedAt(res?.credit_note[0].posted_at)
              } else {
                showMessage('error', res?.message);
                // hideLoading(layoutDispatch);
              }
        
            } catch (err) {
              console.log(err);
              showMessage('error', 'Something went wrong');
              // hideLoading(layoutDispatch);
        
            }
            finally {
              hideLoading(layoutDispatch);
            }
          };

        const postStockData = async () => {
            showLoading(layoutDispatch);
            const dataToSend = {
              id: DetailsCM?.id,
              files: currentItemFiles,
              notes: notes,
            }
            try {
              const res = await Auth.fetch(`/stock/post-cn-stock`, {
                method: "POST",
                body: JSON.stringify(dataToSend)
              });
              if (res?.ack) {
                showMessage('success', res?.message);
                const uploadPromises = []
                        if (files.length > 0) {
                          files.forEach((f) => {
                            uploadPromises.push(
                              getUploadUrl(f, 'receive-returned-stock', documentNumber)
                                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                                .catch(error => console.error("Error uploading file:", error))
                            );
                          });
                        }
                        await Promise.all(uploadPromises);
                        fetchUpdatedDetails()
              } else {
                showMessage('error', res?.message);
                hideLoading(layoutDispatch);
        
              }
        
            } catch (err) {
              console.log(err);
              showMessage('error', 'Something went wrong');
              hideLoading(layoutDispatch);
        
            }
          };
        const saveStockData = async () => {
            showLoading(layoutDispatch);
            const dataToSend = {
              id: DetailsCM?.id,
              files: currentItemFiles,
              notes: notes,
            }
            try {
              const res = await Auth.fetch(`/stock/save-cn-stock`, {
                method: "POST",
                body: JSON.stringify(dataToSend)
              });
              if (res?.ack) {
                showMessage('success', res?.message);
                const uploadPromises = []
                        if (files.length > 0) {
                          files.forEach((f) => {
                            uploadPromises.push(
                              getUploadUrl(f, 'receive-returned-stock', documentNumber)
                                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                                .catch(error => console.error("Error uploading file:", error))
                            );
                          });
                        }
                        await Promise.all(uploadPromises);
                        fetchUpdatedDetails()
              } else {
                showMessage('error', res?.message);
                hideLoading(layoutDispatch);
        
              }
        
            } catch (err) {
              console.log(err);
              showMessage('error', 'Something went wrong');
              hideLoading(layoutDispatch);
        
            }
          };

  const submitImage = (e) => {
    handleSubmitImage(e, setFiles, setCurrentItemFiles)
  }

  const handleValueChange = (value, isScanned) => {
    setDocumentNumber(value);
    if (isScanned) {
      handleSubmit();
    }
  };

  const infoItems = [
      {
        label: 'Customer',
        value: `${DetailsCM?.customer_code} - ${DetailsCM?.customer_name}` || '-',
        icon: <UserOutlined style={{ color: "#52c41a" }} />,
        type: 'text',
      },
      {
        label: 'Posting Date',
        value: DetailsCM?.posting_date ? dayjs(DetailsCM?.posting_date).format('DD-MM-YYYY') : 'N/A',
        icon: <CalendarOutlined style={{ color: "#fa541c" }} />,
        type: 'text',
      }
    ]
  
    // const modalInfoItems = [
    //   {
    //     label: 'Total Qty',
    //     value: `${selectedItem?.fulfilled_quantity || 0}`,
    //     type: 'text',
    //     icon: <NumberOutlined style={{ color: "#1677ff" }}/>
    //   },
    //   {
    //     label: 'Remaining Qty',
    //     value: `${selectedItem?.remaining_quantity || 0}`,
    //     type: 'text',
    //     icon: <NumberOutlined style={{ color: "#1677ff" }}/>
    //   }
    // ]

  // const infoItems = [
  //   {
  //     label: 'Customer',
  //     value: `${DetailsCM?.customer_code} - ${DetailsCM?.customer_name}` || '-'
  //   },
  //   {
  //     label: 'Posting Date',
  //     value: DetailsCM?.posting_date ? dayjs(DetailsCM?.posting_date).format('DD-MM-YYYY') : 'N/A'
  //   },
  // ]

  const modalInfoItems = [
    {
      label: 'Total Qty',
      value: selectedItem?.batch_quantity,
      type: 'text', 
      icon: <NumberOutlined style={{ color: "#1677ff" }} />,
      color: '#1677ff'
    },
    {
      label: 'Remaining Qty',
      value: selectedItem?.remaining_quantity,
      type: 'text', 
      icon: <NumberOutlined style={{ color: "#1677ff" }} />,
      color: selectedItem?.remaining_quantity > 0 ?  'red' : '#1677ff'
    },
    {
          label: "Batch Code",
          value: selectedItem?.batch_code,
          icon: <TagOutlined style={{ color: "#fa541c" }} />,
          type: 'text',
    
        },
        {
          label: "Batch Expiry",
          value:  selectedItem?.expiry_date ? dayjs(selectedItem?.expiry_date).format('DD-MM-YYYY') : '',
          icon: <CalendarOutlined style={{ color: "#fa541c" }} />,
          type: 'text',
    
        },
  ]


  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', marginBottom: '10px' }}>
        <h3 style={{ margin: 0 }}>Receive Returned Stock</h3>
        <AntButton icon={<ArrowLeftOutlined />} onClick={() => navigate("/stocks")}>Back</AntButton>
      </div>
      <Flex justify="space-between" align="center" gap={10} style={{ marginBottom: '16px' }} wrap>
         <Flex gap="small">
            <ScanInput onValueChange={handleValueChange} value={documentNumber} placeholder={'Document Number'} size={'default'} length={'100%'} autoFocus={true} />
            <AntButton type="primary" onClick={handleSubmit}>Search</AntButton>
          </Flex>
          <Flex gap="small">
            {receivedItems?.length > 0 && posted && (
              <CustomTag
              icon={
                <Tooltip title={postedAt ? dayjs(postedAt).format('DD-MM-YYYY HH:mm:ss') : 'N/A'}>
                    <InfoCircleFilled />
                </Tooltip>
              }
                style={{ margin: 0 }}
                color={'red'}
                  >
                  {'Posted'}
                </CustomTag>
              )
          }       
          </Flex>
        </Flex>
     
      <>
        <>
        {
          receivedItems?.length > 0 && (
            <>
            {/* <InfoCards items={infoItems} /> */}
            <DetailsGrid infoItems={infoItems}/>
            </>

          )
        }
          

        </>
        <div style={{ marginTop: "20px" }}>


          <Table
            dataSource={receivedItems}
            columns={dataCol}
            pagination={false}
            scroll={{ x: 'max-content' }}
            rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
          />
        </div>
        {
          receivedItems?.length > 0 && (

            <>
              <Row style={{ marginTop: '5px' }} gutter={[16, 16]}>
                <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                  <span>
                    Notes:
                  </span>
                  <TextArea
                    value={notes}
                    onChange={(e) => { setNotes(e.target.value) }}
                    placeholder='Please enter any notes.'
                    autoSize={{ minRows: 3, maxRows: 6 }} 
                    style={{
                      borderColor: posted === true ? '#1890ff' : undefined,
                      backgroundColor: posted === true ? '#e6f7ff' : undefined,
                      borderWidth: posted === true ? '2px' : undefined,
                    }}
                    />

                </Col>
              </Row>
              <div>
                <UploadButton
                  component="label"
                  variant="contained"
                  sx={{ marginTop: "10px" }}
                  startIcon={<CloudUploadIcon />}
                >
                  Add files
                  <input
                    type="file"
                    hidden
                    multiple
                    capture
                    onChange={(e) => {
                      const myfiles = e.target.files;

                      if (myfiles.length > 10) {
                        showMessage('error', "A maximum of 10 images can be uploaded at a time.");
                        e.target.value = "";
                      } else {
                        submitImage(e);
                      }
                    }}
                  />
                </UploadButton>
              </div>

              {currentItemFiles?.length > 0 && <h4>Current Files:</h4>}
              <ul>
                {currentItemFiles?.length > 0 &&
                  currentItemFiles
                    .filter(
                      (item) =>
                        !files.some((file) => file.name === item)
                    )
                    .map((item) => {
                      const encodedFileName = item.replace(/\+/g, '%2B');
                      return (
                        <li>
                          <IconButton
                            aria-label="delete"
                            color="primary"
                            onClick={() => handleDeleteCurrentFile(item, deletedFiles, setDeletedFiles, currentItemFiles, setCurrentItemFiles,)}
                          >
                            <DeleteIcon />
                          </IconButton>

                          <a
                            href={`${wms_uploads_cdn}/${env}/receive-returned-stock/${documentNumber}/${encodedFileName}`}
                            target="_blank"
                          >
                            {extractOriginalFileName(encodedFileName)}
                          </a>
                        </li>
                      );
                    })}
              </ul>

              {files?.length > 0 && <Divider />}

              {files?.length > 0 && <h4>Files:</h4>}
              <ul>
                {files.length > 0 &&
                  files.map((file) => {
                    const encodedFileName = file?.name.replace(/\+/g, '%2B');
                    return (
                      <li>
                        {" "}
                        <IconButton
                          aria-label="delete"
                          color="primary"
                          onClick={() => handleDeleteFile(file.name, files, currentItemFiles, setFiles, setCurrentItemFiles)}
                        >
                          <DeleteIcon />
                        </IconButton>
                        {extractOriginalFileName(encodedFileName)}
                      </li>
                    );
                  })}
              </ul>
              {files?.length > 0 && <Divider />}
            </>
          )
        }
        {
                  receivedItems?.length > 0 && (
                    <>
                      <Flex justify="end" gap={5} style={{ marginTop: "20px" }}>
                        <AntButton size='large' type="primary" onClick={() => saveStockData()}>Save</AntButton>
                        <>
                          {!posted && (
                            <>
                             <AntButton danger size="large"
                                    disabled={posted}
                                    onClick={() => {
                                      Modal.confirm({
                                        title: 'Post Stock',
                                        centered: true,
                                        content: `Are you sure to post this order? This action cannot be undone.`,
                                        onOk: () => postStockData(),
                                        okText: 'Post',
                                        cancelText: 'Cancel',
                                        width: 600,
                                        okButtonProps: { size: "large" },
                                        cancelButtonProps: { size: "large" },
                                      });
                                    }}
                                  >Post</AntButton>
                            </>
                          )}
                        </>
        
                      </Flex>
                    </>
        
                  )
                }

      </>
      <Modal  width={'70vw'} title={`Receive Returned Stock: ${selectedItem?.product_code} - ${selectedItem?.product_name}`}
                open={modalVisible}
                onCancel={handleModalCancel}
                okButtonProps={{ style: { display: "none" } }}
                cancelButtonProps={{ style: { display: !posted && 'none' } }}
              >
                <Divider style={{ margin: '10px 0'}} />
                {/* <InfoCards items={modalInfoItems} maxColumns={2} /> */}
                <DetailsGrid infoItems={modalInfoItems} />
                {
                  selectedItem?.remaining_quantity > 0 && !posted && (
                    <>
                    <Row style={{ marginBottom: "10px" }}>
                      <Col                   
                      xs={{ span: 24, order: 2 }}
                      md={{ span: 14, order: 1 }}
                    >
                      <Row>
                        <Col style={{flex: 1}}>
                          <Text>Product</Text>
                          <ProductScanSelect
                            onValueChange={productSelectValueChange}
                            value={returnedStock?.product_id}
                            options={products} placeholder="Product"
                            size="large"
                            length={'100%'}
                            productRef={productRef}
                          />
                        </Col>
                      </Row>
      
                      {
                        returnedStock?.product_id && (
                          <Row style={{ marginBottom: "10px" }}>
                       
                        <Col style={{flex: 1}}>
                          <Text>Location</Text>
                          <ScanSelect autoFocus onValueChange={locationSelectValueChange} value={returnedStock?.location_id} options={allLocations} placeholder="Location" size="large" length={'100%'} capacityCheck={true} />
                        </Col>
                      </Row>
                        )
                      }
                      {
                        returnedStock?.location_id && (
                          <>
                          <Row >
                        <Col style={{flex: 1}}>
                          <Text>Supplier Batch Code</Text>
                          <Flex align="center" gap="small">
                            <Input autoFocus size="large" type='text' value={returnedStock?.supplier_batch_code}
                              onChange={(e) => {
                                // const newQty = e.target.value
                                const raw = e.target.value;
                                setReturnedStock({ ...returnedStock, supplier_batch_code: raw })
                              }
                            }
                            placeholder="Supplier Batch Code" />
                             
                            
                          </Flex>
                          
                          
                        </Col>
                      </Row>
                       <Row >
                    <Col style={{flex: 1}}>
                      <Text>Expiry Date<span style={{ color: 'red' }}>*</span></Text>
                      <br />
                      <DatePicker
                        format={'DD-MM-YYYY'}
                        size="large"
                        value={returnedStock?.expiry_date}
                        onChange={(date) => {
                          if (!returnedStock?.product_id) {
                            showMessage('error', 'Select a product first')
                            return;
                          }
                          if (!date) {
                            // If user clears the date
                            setReturnedStock({ ...returnedStock, expiry_date: null,  });
                            return;
                          }
                          setReturnedStock({
                            ...returnedStock,
                            expiry_date: date ? dayjs(date, 'YYYY-MM-DD') : null,
                          })
                        }}
                        placeholder="Expiry Date"
                        disabledDate={(current) => {
                          return current && current < dayjs().startOf('day')
                        }}

                      />
                    </Col>
                    
                  </Row>
                          <Row >
                        <Col style={{flex: 1}}>
                          <Text>Quantity</Text>
                          <Flex align="center" gap="small">
                            <Input autoFocus size="large" type='number' value={returnedStock?.quantity}
                              onChange={(e) => {
                                // const newQty = e.target.value
                                const raw = e.target.value;
                                const newQty = /^\d*$/.test(raw) ? raw.replace(/^0+(?=\d)/, "") : '1';
                                const selectedProduct = products?.find((pro) => pro?.netsuite_id == returnedStock?.product_id);
                                const fullPalletQty = selectedProduct?.cases_in_pallets;
                                // if (newQty < 0) {
                                //   showMessage('error', 'Quantity cannot be negative');
                                //   return;
                                // }
                                if (newQty > fullPalletQty) {
                                  showMessage('error', 'Quantity cannot be grater than pallet capacity');
                                  return;
                                }
                                const remainingQty = selectedItem?.remaining_quantity;
                                if (newQty > remainingQty) {
                                  showMessage('error', `Quantity cannot be greater than ${remainingQty}`)
                                  return;
                                } else {
                                  setReturnedStock({ ...returnedStock, quantity: newQty })
                                }
                              }
                              }
                              placeholder="Enter Quantity" />
                              {
                                returnedStock?.remainQtyShow && (
                                  <Checkbox
                              checked={returnedStock?.remaining_quantity_check}
                              style={{ fontSize: '16px', width: '100%' }}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                const qtyRemaing = selectedItem?.remaining_quantity;
                                const selectedProduct = products?.find((pro) => pro?.netsuite_id == returnedStock?.product_id);
                                const fullPalletQty = selectedProduct?.cases_in_pallets;
      
                                if (isChecked) {
                                  if (!returnedStock?.product_id) {
                                    showMessage('error', 'Please select a product first');
                                    return;
                                  }
      
                                  if ( qtyRemaing > fullPalletQty) {
                                  // showMessage('error', 'Remaining quantity should be less than pallet capacity')
                                  return;
                                } else {
      
                                  setReturnedStock({ ...returnedStock, quantity: qtyRemaing, remaining_quantity_check: isChecked });
                                }
                                  
                                }
                                else {
                                  setReturnedStock({ ...returnedStock, quantity: '', remaining_quantity_check: false });
                                }
                              }}
                            >
                              Remaining Quantity
                            </Checkbox>
                                )
                              }
                              {
                            returnedStock?.fullPalletShow && (
                              <Checkbox
                            checked={returnedStock?.fullPallet}
                            size="large"
                            style={{ marginTop: "10px", width: '100%' }}
                            onChange={(e) => {
                              const isChecked = e.target.checked;
                              if (isChecked) {
                                if (!returnedStock?.product_id) {
                                  showMessage('error', 'Please select a product first');
                                  return;
                                }
                                const selectedProduct = products?.find((pro) => pro?.netsuite_id == returnedStock?.product_id);
                                const qtyRemaing = selectedItem?.remaining_quantity;
                                const fullPalletQty = selectedProduct?.cases_in_pallets;
                                if (fullPalletQty > qtyRemaing) {
                                  showMessage('error', 'Remaining quantity is less than pallet quantity')
                                  return;
                                } else {
                                  setReturnedStock({ ...returnedStock, quantity: fullPalletQty, fullPallet: e.target.checked })
                                }
                              } else {
                                setReturnedStock({ ...returnedStock, quantity: '', fullPallet: false });
                              }
      
                            }
                            }
                          >
                            Full Pallet
                          </Checkbox>
                            )
                          }
                            
                          </Flex>
                          
                          
                        </Col>
                      </Row>
                      </>
                        )
                      }
                      </Col>

                      {returnedStock?.product_id && (
                        <Col 
                          xs={{ span: 24, order: 1 }}
                          md={{ span: 6, offset: 2, order: 2 }}
                          style={{ textAlign: "center", marginBottom: 16 }}
                        >
                          <Image src={imageUrl} width={300} preview={false} />
                        </Col>
                      )}
                    </Row>

                      <Flex justify="end" gap={5}>
                        {
                          (Number(selectedItem.batch_quantity) - Number(selectedItem?.quantityAdded) >= 1) && !posted && (
                            <>
                            <AntButton onClick={() => handleModalCancel()} >Cancel</AntButton>
                            <AntButton disabled={!returnedStock?.product_id} type="primary" onClick={() => handleModalOk()} >Save</AntButton>
                            </>
                          )
                        }
      
                      </Flex>
                      <Divider />
                    </>
                  )
                }
      
      
      
      
                {
                  stockTransactions?.length > 0 &&
                  (
                    <>
                      <h3 style={{ margin: 0 }}>Transactions</h3>
                      <Table
                        columns={transactionCol}
                        dataSource={stockTransactions}
                        pagination={false}
                        scroll={{ x: 'max-content' }}
                        rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")}
                      />
                    </>
                  )
                }
              </Modal>
              <ProductInfoModal
          visible={modalVisibleProduct}
          onCancel={handleModalCancelProduct}
          selectedItemDetails={selectedProductDetails}
          selectedItems={selectedProductDetails?.productDetails}
            // selectedRecord={selectedRecord}
          />
    </>
  );
};

export default ReceiveReturnedStock;
